import React, { useState, useEffect, useRef, Fragment } from "react";
import { useForm, Controller } from "react-hook-form";
import TableWrapper from "../../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { Tooltip, Autocomplete, TextField } from "@mui/material";
import { MdModeEditOutline } from "react-icons/md";
import { callAPI } from "../../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../../core/BaseComponents/Modal";
import deleteImg from '../../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";
import { faImages, faPlay } from '@fortawesome/free-solid-svg-icons';
import { FileUploader } from "react-drag-drop-files";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaHotel } from "react-icons/fa";
import CarouselComponent from "./CarouselComponent ";
import DeleteBannerImage from "./DeleteBannerImage";
import CircularProgress from '@mui/material/CircularProgress';
import Custom_Paingation from "../../../core/BaseComponents/Custom_Paingation";
import { ScrollToTop, getChainIdLS, isValidRole } from "../../../../utils/utils";
import { useSelector } from "react-redux";
import ImageResolutionTooltip from "../../ConfigurationNewHotel/ImageResolutionTooltip";

function ScreensaverConfiguration() {
  const [bannerImagesList, setBannerImagesList] = useState({});
  const [confirmDeleteBannerRow, setConfirmDeleteBannerRow] = useState("");
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [deleteBannerPopUp, setDeleteBannerPopUp] = useState(false);
  const [deleteBannerImagePopUpAPI, setDeleteBannerImagePopUpAPI] = useState(false);
  const [editBannerConfig, setEditBannerConfig] = useState(false);
  const [editBannerRowUpdate, setEditBannerRowUpdate] = useState(false);
  const [createBannerSuccessMsg, setCreateBannerSuccessMsg] = useState('');
  const [editBannerSid, setEditBannerSid] = useState("");
  const [fileError, setFileError] = useState("");
  const [publishUnPublishPopUp, setPublishUnPublishPopUp] = useState(false);
  const [flag, setFlag] = useState(false);
  const [files, setFiles] = useState([]);
  const [fileUrls, setFileUrls] = useState([]);
  const [originalFileUrls, setOriginalFileUrls] = useState([]);
  const [upLoadedFilesLength, setUpLoadedFilesLength] = useState(0);
  const [updatedSelectionType, setUpdatedSelectionType] = useState('');
  const [loader, setLoader] = useState(false);
  const [showPreviewPopUp, setShowPreviewPopUp] = useState(false);
  const [showVideoPreviewPopUp, setvideoShowPreviewPopUp] = useState(false);
  const [listConfigId, setListConfigId] = useState([]);
  const [previewBannerConfigIndex, setPreviewBannerConfigIndex] = useState(0);
  const [initialSlide, setInitialSlide] = useState(0);
  const [isEdit, setIsEdit] = useState(false);

  const [fileUploadSizeErrorPopup, setFileUploadSizeErrorPopup] = useState(false)
  const isEditClick = useRef(false)
  const [onEditClickFlag, setOnEditClickFlag] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    control,
    watch,
    setValue
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      selectionType: 'image',
    }
  });

  let validPermissionClassName = isValidRole("SCREENSAVER_MODIFY")
    ? ""
    : "btn-disable-permission";

    const defaultConfigScreensaverImage = [
      {
        name: "Default Config Screensaver Image",
        files: 15,
        size: "700 KB",
        height: 1080,
        width: 1920,
        resolution: "72 PPI",
        aspect: "16:09",
        formats: "JPG, JPEG, PNG",
      }
    ]

  const textPositionMaster = ["Top Left", "Top Right", "Bottom Left", "Bottom Right", "Centered"];
  // let serviceTypes = ["image"];

  const textPostionClass = (selectedTextPosition) => {
    if (selectedTextPosition === "Top Left") {
      return 'top-left'
    } else if (selectedTextPosition === "Top Right") {
      return 'top-right'
    } else if (selectedTextPosition === "Centered") {
      return 'center'
    } else if (selectedTextPosition === "Bottom Right") {
      return 'bottom-right'
    }
    else if (selectedTextPosition === "Bottom Left") {
      return 'bottom-left'
    }
  }

  const resetHandler = () => {
    setFiles([]);
    setUpLoadedFilesLength(0)
    setFileUrls([]);
    reset({
      name: '',
      roomTypes: [],
      selectionType:'image'
    });
    setEditBannerRowUpdate(false);
    setFileError("");
    setPreviewBannerConfigIndex(0);
    setEditBannerSid({})
  }

  const onSubmit = (data) => {
    if(watch('selectionType') === 'image'){
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        let bytes = (file?.size / (1024)).toFixed(2);
        if (bytes > 700) {
          setFileError(`Upload file should be less than 700KB`);
          return;   
        }
      };
    }
    const formData = new FormData();
    let method = "POST";

    let fileUrlText = fileUrls?.map(item => item.text);
    let fileUrlTextPosition = fileUrls?.map(item => item.textPosition);
    let url = `/screen-saver-default?textPosition=${fileUrlTextPosition}&name=${data?.name}&text=${fileUrlText}&selectionType=${data?.selectionType.toLowerCase()}`;

    if (editBannerRowUpdate) {
      if(watch("selectionType")!==updatedSelectionType){
        if (files.length === 0) {
          setFileError('You must upload at least 1 file');
          return;
        } else if (files.length > 15) {
          setFileError('You can only upload up to 15 files');
          return;
        }
      }
      let updatedText = JSON.stringify(fileUrls?.filter(item => item.id).map(item => ({ imageId: item.id, text: item.text, textPosition: item.textPosition })));
      const fileUrlTextpayload = fileUrls?.filter(item => !item.id).map(item => item.text);
      const fileUrlTextPositionPayload = fileUrls?.filter(item => !item.id).map(item => item.textPosition);
      // formData.append('text', fileUrlText);
      formData.append('text', fileUrlTextpayload);
      formData.append('textPosition', fileUrlTextPositionPayload);
      formData.append('textAndPositionUpdate', updatedText);
      method = "PUT"
      url = `/screen-saver-default?id=${editBannerSid?.id}&name=${data?.name}&selectionType=${data?.selectionType.toLowerCase()}`

      if (files.length + upLoadedFilesLength > 15 && watch('selectionType') === 'image') {
        setFileError(`${upLoadedFilesLength === 15 ? "Delete any of screensaver image to upload new screensaver image" : `${upLoadedFilesLength} of 15 screensaver images are already uploaded. You can only upload ${15 - upLoadedFilesLength} more image${(15 - upLoadedFilesLength) === 1 ? '' : 's'}`}`);
        return;
      }
      setLoader(true);
    } else {
      if (files.length === 0) {
        setFileError('You must upload at least 1 file');
        return;
      } else if (files.length > 15) {
        setFileError('You can only upload up to 15 files');
        return;
      }
      setLoader(true);
    }
    Array.from(files).forEach((file) => {
      formData.append(watch('selectionType') === 'image' ? 'screenSaver' : 'video', file);
    });
    setFileError('');

    callAPI(url, method, formData, { chainId: getChainIdLS() })
      .then(function (response) {
        setLoader(false);
        reset({
          name: '',
          roomTypes: [],
          selectionType:'image'
        });
        setFiles([]);
        setFileUrls([]);
        setCreateBannerSuccessMsg(response?.message);
        BannerListApi();
        setEditBannerSid('');
      })
      .catch(function (error) {
        setLoader(false);
        console.warn(error.response?.data?.errorMessage);
      });
  };

  // const onSave = (data) => {

  //   if (files.length === 0) {
  //     setFileError('You must upload at least 1 file');
  //     return;
  //   } else if (files.length > 15) {
  //     setFileError('You can only upload up to 15 files');
  //     return;
  //   }
  //   if(watch('selectionType') === 'image'){
  //     for (let i = 0; i < files.length; i++) {
  //       const file = files[i];
  //       let bytes = (file?.size / (1024)).toFixed(2);
  //       if (bytes > 700) {
  //         setFileError(`${file.name} file should be less than 700KB`);
  //         return;   
  //       }
  //     };
  //   }
  //   setFileError('');
  //   setLoader(true);
  //   const formData = new FormData();
  //   Array.from(files).forEach((file) => {
  //     formData.append(watch('selectionType') === 'image' ? 'screenSaver' : 'video', file);
  //   });
  //   let fileUrlText = fileUrls?.map(item => item.text);
  //   let fileUrlTextPosition = fileUrls?.map(item => item.textPosition);
  //   let url = `/screen-saver-default?textPosition=${fileUrlTextPosition}&name=${data?.name}&text=${fileUrlText}&selectionType=${data?.selectionType.toLowerCase()}`;

  //   callAPI(url, "POST", formData, { chainId: getChainIdLS() })
  //     .then(function (response) {
  //       setLoader(false);
  //       reset({
  //         name: '',
  //         roomTypes: []
  //       });
  //       setFiles([]);
  //       setFileUrls([]);
  //       setCreateBannerSuccessMsg(response?.message);
  //     })
  //     .catch(function (error) {
  //       setLoader(false);
  //       console.warn(error.response?.data?.errorMessage);
  //     });
  // };

  const isBannerDeletedRef = useRef({
    isBannerDeletedModalData: null,
    userConformationModalData: null,
  });

  const isPublishedUnPublishedRef = useRef({
    isPublishUnPublishModalData: null,
  });

  const isBannerImaageDeletedRef = useRef({
    isBannerImageDeletedModalData: null,
    deleteBannerConformationModalData: null
  });

  const publishUnPublishPopUpHandler = (row) => {
    setPublishUnPublishPopUp(true);
    const newModalRefData = {
      isPublishUnPublishModalData: {
        message: `Do you really want to ${row?.isPublished ? 'Un-Publish' : 'Publish'} the Screensaver Configuration?`,
        row
      }
    };
    isPublishedUnPublishedRef.current = newModalRefData;
  }

  const deleteBannerRowPopUpHandler = (row) => {
    setDeleteBannerPopUp(true);
    const newModalRefData = {
      isBannerDeletedModalData: {
        row
      },
      userConformationModalData: null,
    };
    isBannerDeletedRef.current = newModalRefData;
  }

  const deleteBannerHandler = () => {
    setConfirmValidate(true);
    if (confirmDeleteBannerRow === "") {
      return
    }

    if (confirmDeleteBannerRow === `Delete Screensaver config ${isBannerDeletedRef.current?.isBannerDeletedModalData.row.name}`) {
      setConfirmValidate(false)
      const { row } = isBannerDeletedRef.current?.isBannerDeletedModalData;
      callAPI(`/screen-saver-default/${row?.id}`, "DELETE")
        .then((response) => {
          let successMessage = response.message
          const newModalRefData = {
            isBannerDeletedModalData: null,
            userConformationModalData: {
              successMessage
            },
          };
          isBannerDeletedRef.current = newModalRefData;
          resetHandler();
          BannerListApi();
        })
        .catch((error) => {
          console.warn(error)
        });
    }
    reset({
      name: '',
      roomTypes: []
    });
  }

  const deleteBannerImageHandlerApi = () => {
    const { bannerImage, bannerConfigId } = isBannerImaageDeletedRef.current?.isBannerImageDeletedModalData;
    callAPI(`/screen-saver-default/images/delete?id=${bannerConfigId}&imageId=${bannerImage?.id}`, "DELETE")
      .then((response) => {
        let successMessage = response.message
        const newModalRefData = {
          isBannerImageDeletedModalData: null,
          deleteBannerConformationModalData: {
            successMessage
          },
        };
        isBannerImaageDeletedRef.current = newModalRefData;
        BannerListApi();
      })
      .catch((error) => {
        console.warn(error)
      });
  }

  const renderActionIcon = (row) => {
    return (
      isValidRole("SCREENSAVER_MODIFY")?<>
          <Tooltip title="Edit" arrow>
            <MdModeEditOutline
              className="edit-icon-enable"
              onClick={() => { setEditBannerConfig(true); setEditBannerSid(row); setIsEdit(true) }}
            />
          </Tooltip>
          <Tooltip title="Delete" className="cursor-pointer" arrow>
            <DeleteIcon
              className="delete-icon-enable"
              onClick={() => {
                deleteBannerRowPopUpHandler(row);
              }}
            />
          </Tooltip>
      </>:
      <>
      <Tooltip title="Don't have permission to edit" arrow>
        <span>
          <MdModeEditOutline className="edit-icon-disable" />
        </span>
      </Tooltip>
      <Tooltip title="Don't have permission to delete" arrow>
        <DeleteIcon className="delete-icon-disable" />
      </Tooltip>
    </>
    );
  };

  const renderConfigImages = (row) => {
    let renderImagesOrVideo;
    if (row?.videoUrl === null) {
      renderImagesOrVideo = <div className="delete-config-images">
        {row?.imageResponse?.slice(0, 4)?.map((url, index) => (
          <div key={url?.id}>
            <img src={url?.url} alt={url?.text} onClick={() => BannerPreviewHandler(row, index, 'imgagePreview')} />
            {/* {!row?.isPublished ?
              <Tooltip title={`${row?.imageResponse?.length === 1 ? 'At least one image required in hero banner' : editBannerSid?.id === row?.id ? 'Cancel edit mode to perform actions' : 'Delete'}`}>
                <span className={`${row?.imageResponse?.length === 1 || editBannerSid?.id === row?.id ? 'cross-mark-disabled' : 'cross-mark-enabled'}`} onClick={() => row?.imageResponse?.length === 1 || editBannerSid?.id === row?.id ? "" : handleDeleteBannerAPI(url, row?.id)}>X</span>
              </Tooltip> :
              <Tooltip title="Un-Publish to perform actions">
                <span className="cross-mark-disabled">X</span>
              </Tooltip>} */}
          </div>
        ))}
          {row?.imageResponse?.length>4 && <span>...<span onClick={() => BannerPreviewHandler(row, 0, 'imgagePreview')} className="ms-2 cdsn-count">+{row?.imageResponse?.length-4}</span></span>}
      </div>
    } else {
      renderImagesOrVideo = <Tooltip title={row?.videoUrl} className="screen-saver-video" >
        <video width="400" controls={false} preload="metadata"
        onClick={() => BannerPreviewHandler(row, 0, 'videoPreview')} >
          <source src={`${row?.videoUrl}#t=0.1`} type="video/mp4" />
        </video>
        <FontAwesomeIcon icon={faPlay} className="fa-lg" onClick={() => BannerPreviewHandler(row, 0, 'videoPreview')} />
      </Tooltip>
    }
    return renderImagesOrVideo;
  }


  const columns = [
    { field: "createdOn", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
    { field: "name", headerName: "Config Name", flex: 1 },
    { field: "roomTypes", headerName: "Screensaver Details", flex: 1, row: true, renderCell: renderConfigImages, flex: 0.5, disableSortIcon: true, },
    {
      field: "actionCell",
      row: true,
      headerName: "Actions",
      flex: 0.5,
      renderCell: renderActionIcon,
      sortDirection: false,
      disableSortIcon: true,
    },
  ];

  const BannerListApi = () => {
    setLoader(true);
    const apiPath = `/screen-saver-default`;
    callAPI(apiPath, "GET")
      .then((response) => {
        setLoader(false);
        setBannerImagesList(response)
        // setTotalPageCount(response?.totalPages ? response?.totalPages : 1)
        // setPaginationError("")
      })
      .catch((err) => {
        setLoader(false);
        console.warn(err.message);
      });
      setIsEdit(false);
  };

  useEffect(() => {
    BannerListApi();
  }, []);

  const popupCloseHandler = () => {
    setDeleteBannerPopUp(false);
    setPublishUnPublishPopUp(false);
    setDeleteBannerImagePopUpAPI(false);
  };


  useEffect(() => {
    if (editBannerConfig) {
      getBannerListSidHandler();
      setEditBannerConfig(false);
    }
    ScrollToTop();
  }, [editBannerConfig]);

  useEffect(() => {
    if (isEditClick.current) {
      isEditClick.current = false
    }
    else {
      setFiles([]);
      setFileUrls([]);
      setFileError('');
    }
  }, [onEditClickFlag])

  const getBannerListSidHandler = () => {
    setLoader(true);
    callAPI(`/screen-saver-default/${editBannerSid?.id}`, "GET")
      .then(function (response) {
        setLoader(false);
        isEditClick.current = true
        const payload = {
          name: response?.name,
          selectionType: response?.selectionType
        };
        setFiles([]);
        setUpLoadedFilesLength(response?.imageResponse?.length)
        setUpdatedSelectionType(response?.selectionType);
        setFileUrls(response?.selectionType === "image" ? response?.imageResponse?.map(item => ({ ...item, text: item?.text ? item?.text : " ", delete: false })) : [{ url: response?.videoUrl }]);
        setOriginalFileUrls(response?.selectionType === "image" ? response?.imageResponse?.map(item => ({ ...item, text: item?.text ? item?.text : " ", delete: false })) : [{ url: response?.videoUrl }])
        reset(payload);
        setEditBannerRowUpdate(true);
        setFileError("");
        setPreviewBannerConfigIndex(0);
        setOnEditClickFlag((prev) => !prev)
      })
      .catch(function (error) {
        setLoader(false);
        console.warn(error.response?.data?.errorMessage);
      });
  }

  const resetLayoutHandler = () => {
    reset();
    setFileUrls(originalFileUrls);
    setFiles([]);
  }

  const cancelBannerHandler = () => {
    reset({
      name: '',
    });
    setFileUrls([]);
    setFiles([]);
    setEditBannerRowUpdate(false);
    setEditBannerSid('');
    setEditBannerConfig(false);
    setFileError("");
    setValue('selectionType', 'image');
    setUpLoadedFilesLength(0);
     setIsEdit(false);
  }

  const uploadOrDragFileHandler = (fileList) => {
    const selectedFiles = Array.from(fileList);
    if (watch('selectionType') === 'image') {
      const urls = [];
      setFiles((prev) => [...selectedFiles, ...prev]);
      selectedFiles.map((file) => urls.push({ url: URL.createObjectURL(file), delete: true, text: ' ', textPosition: ' ' }));
      setFileUrls((prev) => [...urls, ...prev]);
    } else if (watch('selectionType') === 'video') {
      const urls = [];
      setFiles(selectedFiles);
      selectedFiles.map((file) => urls.push({ url: URL.createObjectURL(file), type: file?.type, name: file?.name }));
      setFileUrls(urls);
    }
    setFileError('');
  }

  const handleDeleteBanner = (index) => {
    // Revoke the object URL for the deleted file
    URL.revokeObjectURL(fileUrls[index]);

    // Update the state
    const newFiles = files.filter((_, i) => i !== index);
    const newFileUrls = fileUrls.filter((_, i) => i !== index);
    setPreviewBannerConfigIndex(index ? index - 1 : 0);
    setFiles(newFiles);
    setFileUrls(newFileUrls);
  };

  const handleDeleteBannerAPI = (banner, bannerConfigId) => {
    setDeleteBannerImagePopUpAPI(true);
    const newModalRefData = {
      isBannerImageDeletedModalData: {
        bannerImage: banner,
        bannerConfigId: bannerConfigId
      },
      deleteBannerConformationModalData: null
    };
    isBannerImaageDeletedRef.current = newModalRefData;

  }

  const BannerPreviewHandler = (configId, index, preview) => {
    setListConfigId(configId);
    if (preview === "imgagePreview") {
      setShowPreviewPopUp(true);
      setInitialSlide(index);
    } else if (preview === "videoPreview") {
      setvideoShowPreviewPopUp(true);
    }

  }

  const handleTextChange = (e) => {
    setFileUrls(prev =>
      prev.map((item, index) =>
        index === previewBannerConfigIndex ? { ...item, text: e.target.value } : item
      )
    );
  }

  return (
    <div className='row config-hotel config-management-form mx-0'>
      <div className='col-12 left-column'>
        {loader && <div className="circular-progress"><CircularProgress /></div>}
         <form autoComplete="off"  onSubmit={handleSubmit(onSubmit)} className={`hotel-list-form ${isEdit ?"":bannerImagesList?.length ?"page-mask":""} `}>
          {bannerImagesList?.length>0 && !isEdit && <div className='mask-content default-config'>Only one default configuration can be created at a time. <br/> Please update existing one if required.</div> }
          <div className="row">
            <div className="left-column-header">
              <p>{editBannerRowUpdate ? 'Edit Screensaver Configuration' : 'Add Screensaver Configuration'}</p>
            </div>
            <div className="form-group-hotel col-4">
              <div className="floating-label">
                <FaHotel className="new-hotel-icons" />
                <input
                  id="name"
                  maxLength={40}
                  placeholder=""
                  {...register("name", {
                    required: "Enter Configuration Name",
                  })}
                />
                <label htmlFor="name">Enter Configuration Name</label>
              </div>
              {errors.name && (
                <small className="required">{errors.name.message}</small>
              )}
            </div>
            {/* <div className="form-group-hotel col-4">
              <div className="floating-select-label">
                <Controller
                  name="selectionType"
                  control={control}
                  rules={{
                    validate: (value) => (value !== undefined && value !== null && value !== '') || 'Please select selection type',
                  }}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      className={`multiselectlist ${field?.value && field?.value?.length > 0 ? 'Mui-focused' : ''}`}
                      disablePortal
                      options={serviceTypes}
                      // disabled={editBannerRowUpdate}
                      getOptionLabel={(option) => option}
                      onChange={(_, newValue) => {
                        field.onChange(newValue);
                        setOnEditClickFlag((prev) => !prev)
                      }}
                      value={field.value || ''}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder=""
                          variant="outlined"
                          label="Screensaver Type"
                          InputLabelProps={{
                            shrink: false,
                          }}
                        />
                      )}
                    />
                  )}
                />
              </div>
              {errors.selectionType && (
                <small className="required">{errors.selectionType?.message}</small>
              )}
            </div> */}
            <div className="form-group-hotel col-12">
              <p className="banner-title">{editBannerRowUpdate ? 'Edit' : 'Add'} Screensaver {watch('selectionType') === 'image' ? "Image" : "Video"}</p>
              <div className="row mx-0">
                {fileUrls?.length > 0 && watch('selectionType') === 'image' && <div className="col-9 upload-img">
                  <img src={fileUrls[previewBannerConfigIndex]?.url} alt={fileUrls[previewBannerConfigIndex]?.url} />
                  <p className={textPostionClass(fileUrls[previewBannerConfigIndex]?.textPosition)}>{fileUrls[previewBannerConfigIndex]?.text}</p>
                </div>}
                {fileUrls?.length > 0 && watch('selectionType') === 'video' && <div className="col-9 px-0 upload-img partner-logo">

                  <video className="col-12" controls key={fileUrls[0]?.url}>
                    <source src={fileUrls[0]?.url} type={fileUrls?.type} />
                    Your browser does not support the video tag.
                  </video>
                  {/* <span onClick={() => handleDeleteBanner(0)}>X</span> */}
                </div>}
                <div className={`${fileUrls.length > 0 ? 'col-3 file-upload-bg' : 'col-12 file-upload'}`}>
                  <FileUploader
                    name="file"
                    // types={["JPG", "PNG", 'JPEG']}
                    types={watch('selectionType') === 'image' ? ["JPG", "PNG", 'JPEG'] : ["MP4"]}
                    maxSize={100}
                    onSizeError={(file) => setFileUploadSizeErrorPopup(true)}
                    multiple={true}
                    handleChange={uploadOrDragFileHandler}
                    classes="drag-file"
                    children={
                      <>
                        <FontAwesomeIcon icon={faImages} className="fa-lg" />
                        <p className="drag-text">
                          Drag and drop your file's here, or
                          <span> Browse</span>
                          <br />
                          To {editBannerRowUpdate ? "Add New" : "Upload"} <span className="Roboto-Bold text-black">{watch('selectionType') === 'image' ? "Screensaver Images" : "video"}</span> here.
                          <ImageResolutionTooltip data={defaultConfigScreensaverImage}/>
                        </p>
                        {/* {watch('selectionType') === 'image' ? <h6>Max file allowed : 15 {fileError===""&&"and Max File Size: 700 KB"} <br /> Formats Supported : JPG, JPEG and PNG</h6> :
                          <h6>Formats Supported : MP4</h6>} */}
                      </>
                    }
                  />
                  {fileError && <p className="required">{fileError}</p>}
                </div>
                <div className="col-12 management-images mt-3 position-static ps-0 upload-img_url">
                  {watch('selectionType') === 'image' && fileUrls?.map((url, index) =>
                    <div key={index}>
                      <img src={url?.url} alt={url?.url} onClick={() => setPreviewBannerConfigIndex(index)} className={`${fileUrls[previewBannerConfigIndex]?.url === url?.url ? 'selected-image' : ''}`} />
                      {url?.delete && <span onClick={() => handleDeleteBanner(index)}>X</span>}
                    </div>
                  )}
                </div>


                {(fileUrls?.length > 0 && watch('selectionType') === 'image') && <>
                  {fileUrls?.map((url, index) =>
                    <Fragment>
                      {fileUrls[previewBannerConfigIndex] === url && <div key={index} className="d-flex">
                       
                        <div className="form-group-hotel col-3 mt-3">
                          <div className="floating-label">
                            <input
                              type="text"
                              maxLength={255}
                              value={url.text ? url.text : ""}
                              id={url.id}
                              onChange={handleTextChange}
                            />
                            <label htmlFor="name">Enter Sceensaver text</label>
                          </div>
                        </div>
                        {/* <div className="col-3 form-group-hotel mt-3 mx-3">
                          <div className="floating-select-label">
                            <Controller
                              name="textPosition"
                              control={control}
                              // rules={{
                              //   validate: (value) => (value !== undefined && value !== null && value !== '') || 'Please Select Text Position'
                              // }}
                              render={({ field }) => (
                                <Autocomplete
                                  {...field}
                                  className={`multiselectlist ${url?.textPosition && url?.textPosition.length > 0 ? 'Mui-focused' : ''}`}
                                  // limitTags={2}
                                  disablePortal
                                  // multiple
                                  options={textPositionMaster}
                                  getOptionLabel={(option) => option.toString()}
                                  onChange={(_, newValue) => {
                                    field.onChange(newValue);
                                    setFileUrls(prev =>
                                      prev.map((item, index) =>
                                        index === previewBannerConfigIndex ? { ...item, textPosition: newValue } : item
                                      )
                                    );
                                  }}
                                  value={url.textPosition ? url.textPosition : ' '}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder=""
                                      variant="outlined"
                                      label="Select Text Position"
                                      InputLabelProps={{
                                        shrink: false,
                                      }}
                                    />
                                  )}
                                />
                              )}
                            />
                          </div>
                        </div> */}
                      </div>}
                    </Fragment>
                  )}
                </>}
              </div>
            </div>
            <div className="text-end">
              <div>
                <button type="button" className="clear-btn me-2" onClick={cancelBannerHandler}>{editBannerRowUpdate ? "Cancel" : "Clear All"}</button>
                {editBannerRowUpdate && <>
                  <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
                </>}
                {/* {!editBannerRowUpdate && <button type="button" disabled={isSubmitting} className="disable-btn me-2" onClick={handleSubmit(onSave)}>Save</button>} */}
                <button type="button" disabled={isSubmitting} className={`create-btn ${validPermissionClassName}`} onClick={handleSubmit(onSubmit)}>{editBannerRowUpdate ? "Update" : "Save"}</button>
              </div>
            </div>
          </div>
        </form>
        <div className="hotel-list">
          <p><b>Configuration List</b></p>
          <TableWrapper
            data={bannerImagesList?.length?bannerImagesList:[]}
            columns={columns}
            module="banner-config"
            noPagination={true}
          />
          {/* <Custom_Paingation
            selectedPage={selectedPage}
            totalPageCount={totalPageCount}
            paginationError={paginationError}
            inputPageValue={inputPageValue}
            setSelectedPage={setSelectedPage}
            setPaginationError={setPaginationError}
            setInputPageValue={setInputPageValue}
            onPageChange={onPageChange}
          /> */}
        </div>

      </div>
      {showPreviewPopUp && <CarouselComponent
        showPreviewPopUp={showPreviewPopUp}
        listConfigId={listConfigId?.id}
        setShowPreviewPopUp={setShowPreviewPopUp}
        initialSlide={initialSlide}
        BannerListApi={BannerListApi}
        textPostionClass={textPostionClass}
        editBannerSid={editBannerSid}
        handleDeleteBannerAPI={handleDeleteBannerAPI}
      />}
      <DeleteBannerImage
        deleteBannerImagePopUp={deleteBannerImagePopUpAPI}
        popupCloseHandler={popupCloseHandler}
        deleteBannerImageHandlerApi={deleteBannerImageHandlerApi}
        isBannerImaageDeletedRef={isBannerImaageDeletedRef}
      />
      {/* <ConfigrationActions /> */}
      <BasicModal
        popupOpen={deleteBannerPopUp}
        bodyMessage={<>
          <img src={deleteImg} alt="approve" className="w-40px" />
          <div className="delete-hotel mb-3">{isBannerDeletedRef.current?.isBannerDeletedModalData ?
            <div className="confirm-delete-hotel">
              <p>Do you really want to Delete Screensaver config"<b>{isBannerDeletedRef.current?.isBannerDeletedModalData.row.name}</b>" ?</p>
              <p className="warning"><IoMdWarning /> Warning</p>
              <p>Screensaver config"{isBannerDeletedRef.current?.isBannerDeletedModalData.row.name}" will be permanently deleted <br />
                Deleting the specified Screensaver config can't be undone.
              </p>
              <p className="mt-3">To confirm deletion, type "Delete Screensaver config {isBannerDeletedRef.current?.isBannerDeletedModalData.row.name}"</p>
              <div className="form-group-hotel mt-3">
                <div className="floating-label">
                  <input
                    id="deleteHotel"
                    // maxLength={30}
                    placeholder=''
                    onChange={(e) => setConfirmDeleteBannerRow(e.target.value)}
                  />
                  <label htmlFor="deleteHotel">Delete Screensaver config</label>
                </div>
                {(confirmDeleteBannerRow === "" && confirmValidate) ? (
                  <p className="text-start"><small className="required">Please Enter Delete Screensaver config {isBannerDeletedRef.current?.isBannerDeletedModalData.row.name}</small></p>
                ) : (confirmDeleteBannerRow !== `Delete Screensaver config ${isBannerDeletedRef.current?.isBannerDeletedModalData.row.name}` && confirmValidate) ? (
                  <p className="text-start"><small className="required">Please Enter Delete Screensaver config {isBannerDeletedRef.current?.isBannerDeletedModalData.row.name}</small></p>
                ) : ""
                }
              </div>
            </div> :
            isBannerDeletedRef.current?.userConformationModalData?.successMessage}</div>
        </>
        }
        footer={
          isBannerDeletedRef.current?.isBannerDeletedModalData ?
            {
              primaryButton: {
                buttonName: "Cancel",
                action: popupCloseHandler
              }
              ,
              secondaryButton: {
                buttonName: "Delete",
                action: deleteBannerHandler
              }
            } : {
              secondaryButton: {
                buttonName: "OK",
                action: popupCloseHandler
              }
            }
        }
      />

      <BasicModal
        popupOpen={createBannerSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createBannerSuccessMsg}</p>}
        // customcss={true}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setCreateBannerSuccessMsg(''); setEditBannerRowUpdate(false); BannerListApi(); },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />

      {showVideoPreviewPopUp && <BasicModal
        popupOpen={showVideoPreviewPopUp}
        popupSize='col-8 px-5'
        // logo={"/Images/approve-qc.png"}
        bodyMessage={<div className="mt-2">
          <video controls className="w-100">
            <source src={listConfigId?.videoUrl} />
            Your browser does not support the video tag.
          </video>
        </div>}
        // customcss={true}
        footer={
          {
            secondaryButton: {
              buttonName: "Close",
              action: () => { setvideoShowPreviewPopUp(false) },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />}

      <BasicModal
        popupOpen={fileUploadSizeErrorPopup}
        logo={"/Images/Rejected.png"}
        bodyMessage={<>
          <p className="mt-2">Please Upload file size less than 700 KB</p>
        </>
        }
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => setFileUploadSizeErrorPopup(false)
            }
          }
        }
      />
    </div>
  )
}

export default ScreensaverConfiguration;